import {
  REQUEST_MANIFEST,
  RECEIVE_MANIFEST,
  FAILED_MANIFEST
} from '../actions/manifest'

const initialState = {
  isFetching: false,
  items: [],
  skillGroups: []
}

export function frameworkskills(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: true,
        items: [],
        skillGroups: []
      })
    }
    case RECEIVE_MANIFEST: {
      const frameworkSkillsArray = [...action.payload.manifest.framework_skills]
      const frameworkSkillGroups = [
        ...action.payload.manifest.framework_skill_groups
      ]

      return Object.assign({}, state, {
        items: frameworkSkillsArray,
        skillGroups: frameworkSkillGroups,
        isFetching: false
      })
    }
    case FAILED_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: false,
        items: [],
        skillGroups: []
      })
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/frameworkskills.js